import { getLocalStorageLanguage } from 'commons';
import { LANGUAGE_MAP, SystemLanguageType } from 'constant/language';

const RAW_BRAND_LIST = [
  {
    value: 'Hermes',
    nameJa: 'エルメス',
    nameZh: '爱马仕',
    nameEn: 'Hermès',
    descJa: ' HERMÈS エルメス ',
    descZh: ' HERMÈS 爱马仕 ',
    descEn: ' HERMÈS ',
    descZhTw: ' HERMÈS 愛馬仕 ',
  },
  {
    value: 'Chanel',
    nameJa: 'シャネル',
    nameZh: '香奈儿',
    nameEn: 'Chanel',
    descJa: ' CHANEL シャネル ',
    descZh: ' CHANEL 香奈儿 ',
    descEn: ' CHANEL ',
    descZhTw: ' CHANEL 香奈兒 ',
  },
  {
    value: 'XIAOMA',
    nameJa: 'XIAOMA',
    nameZh: 'XIAOMA',
    nameEn: 'XIAOMA',
    descJa: ' XIAOMA ',
    descZh: ' XIAOMA ',
    descEn: ' XIAOMA ',
    descZhTw: ' XIAOMA ',
  },
  {
    value: 'Mira',
    nameJa: 'Mira',
    nameZh: 'Mira',
    nameEn: 'Mira',
    descJa: ' Mira ',
    descZh: ' Mira ',
    descEn: ' Mira ',
    descZhTw: ' Mira ',
  },
  {
    value: 'Other',
    nameJa: 'その他',
    nameZh: '其他',
    nameEn: 'Other',
    descJa: '',
    descZh: '',
    descEn: '',
    descZhTw: '',
  },
] as const;

export type BrandType = {
  value: string;
  label: string;
  descJa: string;
  descZh: string;
  descEn: string;
  descZhTw: string;
};

export type BrandOption = {
  value: string;
  label: string;
};

export const BRAND_LIST = RAW_BRAND_LIST;

export const getBrandList = (
  language: SystemLanguageType = getLocalStorageLanguage(),
): BrandType[] =>
  RAW_BRAND_LIST.map(({ value, nameZh, nameEn, nameJa, ...rest }) => {
    const labelMap = {
      [LANGUAGE_MAP.EN]: nameEn,
      [LANGUAGE_MAP.JA]: nameJa,
      [LANGUAGE_MAP.ZH_CN]: nameZh,
    };

    return {
      value,
      label: labelMap[language],
      ...rest,
    };
  });

export const getBrandOptions = (
  language: SystemLanguageType = getLocalStorageLanguage(),
): BrandOption[] =>
  getBrandList(language).map(({ value, label }) => ({
    value,
    label,
  }));
